function _empty() {}

/* global FormData */

/* eslint no-underscore-dangle:0 */
const {
  poll
} = require('../../utils/poll');

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

class SocialMediaRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context; // eslint-disable-next-line no-use-before-define

    this.for = (id
    /*: string*/
    ) => new SocialMediaInstanceRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  _getUploadTokenAndUrl({
    mediaType,
    mimeType,
    width,
    height,
    size,
    duration
  }, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/media/upload/token`, {
      mediaType,
      mimeType,
      width,
      height,
      size,
      duration // ms

    }, ['token', 'uploadUrl']);
    return this.client.post(req);
  } // eslint-disable-next-line class-methods-use-this


  _upload(uploadToken, file) {
    return _call(function () {
      const uploadUrl = uploadToken.uploadUrl;
      const data = new FormData();
      data.append('file', file);
      return _await(_awaitIgnored(fetch(uploadUrl, {
        method: 'POST',
        body: data
      })));
    });
  }

  _publish(uploadToken) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/media/upload/publish`, {
      token: uploadToken.token
    }, ['id']);
    return this.client.post(req);
  }

  create({
    /*: {
        file: File,
        mediaType: string,
        mimeType: string,
        width: number,
        height: number,
        size: number,
        duration: number
      }*/

    file,
    mediaType,
    mimeType,
    width,
    height,
    size,
    duration
  })
  /*: Promise<string>*/
  {
    const _this = this;

    return _call(function () {
      return _await(_this._getUploadTokenAndUrl({
        mediaType,
        mimeType,
        width,
        height,
        size,
        duration
      }), function (uploadToken) {
        return _await(_this._upload(uploadToken, file), function () {
          return _await(_this._publish(uploadToken), function ({
            id
          }) {
            return _await(_this.for(id)._pollStatus(), function () {
              return id;
            });
          });
        });
      });
    });
  }

}

class SocialMediaInstanceRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: string*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  _status() {
    const {
      businessId
    } = this.context.serialize();
    const id = this.id;
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/media/upload/status`, {
      id
    }, ['id', 'status', 'details', 'created']);
    return this.client.get(req);
  }

  _pollStatus() {
    const _this2 = this;

    return _call(function () {
      const predicate = _async(function () {
        return _await(_this2._status(), function ({
          id,
          status,
          details
        }) {
          if (status === 'unknown') return true;
          if (status === 'READY') return true;
          if (status === 'ERROR') throw new Error(`Failed to publish media ${id} (${details})`);
          return false;
        });
      });

      return _await(_awaitIgnored(poll(predicate, 1000, 60000)));
    });
  }

}

module.exports = SocialMediaRepo;